import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import liveInShedImage from '@/assets/live-in-shed.jpg';

const CanSomeoneLiveInShedCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/live-in-shed-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={liveInShedImage} 
              alt="Converted shed meeting building codes" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Can Someone Live in a Shed in California?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Explore the legality and building code requirements for converting sheds into livable spaces in California. Understand permits, zoning, and city regulations.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                California Regulations for Living in a Shed
              </h2>
              <p className="text-white leading-relaxed mb-6">
                California building codes prohibit occupancy of structures not designed for human habitation unless they meet residential standards. Sheds must be converted to comply with building codes including proper foundation, electrical, plumbing, insulation, and ventilation systems. Most shed conversions require reclassification as ADUs or habitable structures through local permitting processes.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Requirements for Making a Shed Habitable
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Converting sheds to habitable spaces requires permanent foundations, adequate ceiling height (minimum 7 feet), proper electrical service, plumbing installations, and HVAC systems. Windows must provide natural light and emergency egress, while walls need proper insulation and fire-rated materials. All work requires building permits and inspections for legal occupancy.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                City-specific Shed-to-Living Space Rules
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Cities across California maintain varying standards for shed conversions. Some jurisdictions require complete reconstruction to current codes, while others allow modifications with conditional permits. Zoning restrictions may limit where shed conversions are permitted, and homeowners associations may impose additional design requirements for converted structures.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Is it legal to live in a shed in my backyard in California?</p>
                  <p>A: Only if it meets residential building codes, has proper permits, and is zoned correctly as a dwelling.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: How can I legally convert a shed into living space?</p>
                  <p>A: Obtain permits, ensure compliance with building codes, and possibly reclassify as an ADU.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default CanSomeoneLiveInShedCalifornia;